import React, { useState } from "react";
import AnalysisWidget from "./AnalysisWidget.jsx";

export function TopPosters({
  widgetParams,
  feedsParams,
  setFeedsParams,
  setShowFeedsList,
  applyFilterTS,
  widgetList,
}) {
  const [fromUserName, setFromUserName] = useState("");
  if (!widgetParams || !Object.keys(widgetParams).length) {
    return null;
  }
  let tempWidgetList = [...widgetList];
  const vertical = widgetParams.selectedVertical;
  if (Array.isArray(vertical)) {
    tempWidgetList = tempWidgetList.filter((w) => {
      if (
        (vertical.indexOf(w.type.toString()) !== -1 ||
        vertical.indexOf(w.type) !== -1)
      ) {
        return w;
      }
      return null;
    });
  }
  return (
    <React.Fragment key={vertical}>
      {tempWidgetList &&
        tempWidgetList.map((w) => {
          return (
            <AnalysisWidget
              widgetParams={{ ...w, ...widgetParams }}
              feedsParams={feedsParams}
              setFeedsParams={setFeedsParams}
              setShowFeedsList={setShowFeedsList}
              applyFilterTS={applyFilterTS}
              setFromUserName={setFromUserName}
              fromUserName={fromUserName}
            />
          );
        })}
    </React.Fragment>
  );
}
